var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Children, isValidElement } from 'react';
import { SimpleForm as RaSimpleForm, usePermissions, useResourceContext, } from 'react-admin';
import { canAccess } from '../canAccess';
import { Toolbar } from './Toolbar';
/**
 * Alternative to react-admin's <SimpleForm> that adds RBAC control to inputs
 *
 * To see an input, the user must have the permission to write the resource field:
 * { "action": "write", "resource": `${resource}.${source}` }
 *
 * SimpleForm also renders the delete button only if the user has the 'delete' permission.
 *
 * @example
 * import { SimpleForm } from '@react-admin/ra-rbac';
 *
 * const authProvider = {
 *     // ...
 *     getPermissions: () => Promise.resolve([
 *         // 'delete' is missing
 *         { action: ['list', 'edit'], resource: 'products' },
 *         { action: 'write', resource: 'products.reference' },
 *         { action: 'write', resource: 'products.width' },
 *         { action: 'write', resource: 'products.height' },
 *         // 'products.description' is missing
 *         { action: 'write', resource: 'products.thumbnail' },
 *         // 'products.image' is missing
 *     ]),
 * };
 *
 * const ProductEdit = () => (
 *     <Edit>
 *         <SimpleForm> // <-- RBAC SimpleForm
 *             <TextInput source="reference" />
 *             <TextInput source="width" />
 *             <TextInput source="height" />
 *             // not displayed
 *             <TextInput source="description" />
 *             // not displayed
 *             <TextInput source="image" />
 *             <TextInput source="thumbnail" />
 *             // no delete button
 *         </SimpleForm>
 *     </Edit>
 * );
 */
export var SimpleForm = function (props) {
    var resource = useResourceContext();
    var children = props.children, rest = __rest(props, ["children"]);
    var _a = usePermissions(), isLoading = _a.isLoading, permissions = _a.permissions;
    if (isLoading) {
        return null;
    }
    return (React.createElement(RaSimpleForm, __assign({ toolbar: React.createElement(Toolbar, null) }, rest), Children.map(children, function (child) {
        return isValidElement(child) &&
            canAccess({
                permissions: permissions,
                action: 'write',
                resource: resource + "." + child.props.source,
            })
            ? child
            : null;
    })));
};
SimpleForm.propTypes = RaSimpleForm.propTypes;
